var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"open-face",on:{"click":function($event){return _vm.openFace()}}},[_vm._v("活体")]),_c('span',{staticClass:"open-face-callback"},[_vm._v("活体回调数据： "+_vm._s(this.openFaceCallbackData))])])
}
var staticRenderFns = []

export { render, staticRenderFns }